<!-- src/components/LandCover.vue -->
<template>
  <div class="container">
    <el-row class="full-height full-width">
      <el-col :span="6">
        <div class="full-width full-height">
          <div class="overlayCustom" id="expandCustomControl">
            <div class=" demo-form-inline-div">
              <div class="pannelTitle">
                Parameters
              </div>
              <div class="divSide1">
                <el-form :inline="false" :model="formInline" class="demo-form-inline full-height formcss"
                         label-position="top"
                         ref="mapControl">
                  <el-form-item label="Select Year">
                    <el-select
                        v-model="formInline.year"
                        placeholder="Select Year"
                        style="width: 100%"
                        @change="changeYear"
                    >
                      <el-option
                          v-for="item in LCoptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <div>
                    <el-radio-group v-model="formInline.radioNav" size="large" @change="adminPhysioChange()">
                      <el-radio-button label="Administrative Area" value="Admin"/>
                      <el-radio-button label="Physiographic Area" value="Physio"/>
                    </el-radio-group>
                  </div>
                  <br>
                  <el-form-item label="" v-if="formInline.radioNav=='Admin'">
                    <el-select
                        v-model="formInline.adminLevel"
                        placeholder="Administrative Level"
                        @change="changeAdminLevel"
                        style="width: 100%"
                    >
                      <el-option
                          v-for="item in adminLevelOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="formInline.adminLevel != 0 && formInline.radioNav=='Admin'">
                    <el-select
                        v-model="formInline.adminLevelId"
                        style="width: 100%"
                        @change="changeDefaultAminLevelSel"
                        filterable
                    >
                      <el-option
                          v-for="item in adminLevelOptionList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item v-if="formInline.radioNav=='Physio'">
                    <el-select
                        v-model="formInline.physioId"
                        style="width: 100%"
                        filterable
                        @change="changeAnalysisChange"
                    >
                      <el-option
                          v-for="item in physiographyOptionList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-form-item>


                  <el-form-item label="Change Analysis">
                    <el-select
                        v-model="formInline.plottype"
                        style="width: 100%"
                        placeholder="Select Plot Type"
                        @change="changeAnalysisChange"
                    >
                      <el-option
                          v-for="item in plottypeOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-form-item>


                </el-form>
              </div>
              <div class="pannelTitle">
                Layer switcher
              </div>
              <div class="divSide2">
                <div class="layerCollection">
                </div>
              </div>
              <div class="pannelTitle">
                About
              </div>
              <div class="divSide3">
                <el-scrollbar height="100%">
                  <div class="infoabout">
                    <h3>Nepal Land Cover Information System</h3>
                    <p>
                      The Nepal Land Cover system was created by RIMES as part of the CARE Project Component 1. It uses
                      freely available datasets, allowing users to interactively view land cover distribution and trends
                      at specific administrative levels. The data is sourced from Esri Land Cover. For more information
                      about the data, please visit the <a href="https://livingatlas.arcgis.com/landcover/">website</a>
                    </p>
                  </div>
                </el-scrollbar>

              </div>

            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="div1">
          <div id="map" class="full-height full-width">
          </div>
        </div>


        <div class="div2">
          <div id="chartArea" class="full-height full-width"></div>
        </div>


        <!--    <div class="overlayCustom" id="expandCustomControl">-->
        <!--      <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="mapControl">-->
        <!--        <el-form-item label="Select Year">-->
        <!--          <el-select-->
        <!--              v-model="formInline.year"-->
        <!--              placeholder="Select Year"-->
        <!--              style="width: 120px"-->
        <!--              @change="changeYear"-->
        <!--          >-->
        <!--            <el-option-->
        <!--                v-for="item in LCoptions"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->


        <!--        <el-form-item label="Administrative Level">-->
        <!--          <el-select-->
        <!--              v-model="formInline.adminLevel"-->
        <!--              placeholder="Administrative Level"-->
        <!--              style="width: 180px"-->
        <!--              @change="changeAdminLevel"-->

        <!--          >-->
        <!--            <el-option-->
        <!--                v-for="item in adminLevelOption"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value"-->
        <!--            />-->
        <!--          </el-select>-->


        <!--          &nbsp; &nbsp; &nbsp;-->

        <!--          <el-select-->
        <!--              v-model="formInline.adminLevelId"-->
        <!--              style="width: 180px"-->
        <!--              @change="changeDefaultAminLevelSel"-->
        <!--              v-if="formInline.adminLevel!=0"-->
        <!--              filterable-->

        <!--          >-->
        <!--            <el-option-->
        <!--                v-for="item in adminLevelOptionList"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--      </el-form>-->
        <!--    </div>-->

        <div class="legendSection" id="LegendId">
          <div class="tilteLegend">
            &nbsp;&nbsp; Legend
          </div>
          <div class="allLC">

            <el-checkbox
                v-for="(color, index) in colors"
                :key="index"
                v-model="checkedValues[index]"
                @change="handleLCCheckboxChange(index)"
            >
              <span :style="{ backgroundColor: color.color }" class="ledsp" size="large"></span>
              &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;{{ color.label }}
            </el-checkbox>
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>


import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
// import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import View from 'ol/View';
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import Geoportail from "ol-ext/layer/Geoportail";

import {fromLonLat} from 'ol/proj';


import RasterSource from 'ol/source/Raster';
import {Image as ImageLayer} from 'ol/layer';

// import Group from 'ol/layer/Group';
// import LayerSwitcher from "ol-ext/control/LayerSwitcher"
import LayerSwitcherImage from "ol-ext/control/LayerSwitcherImage"
import Control from "ol/control/Control";

import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';

exporting(Highcharts);
exportData(Highcharts);

import Mask from 'ol-ext/filter/Mask';
import Fill from "ol/style/Fill";
import Feature from "ol/Feature";
import MultiPolygon from "ol/geom/MultiPolygon"
import Polygon from "ol/geom/Polygon"

import Crop from "ol-ext/filter/Crop"
import XYZSource from "ol/source/XYZ"
import {
  ProvinceOption,
  DistrictOption,
  municipalityOption,
  LCYear,
  AdministrativeLabelOption,
  NepalExtent,
  LegendValues,
  PlotType
} from "../data";


import {hosts} from "@/modules/api";

import {imagePostFunction} from "../utils/helpers"
import OLPlusLayerSwitcher from "ol-plus/ui/LayerSwitcher";


const centerCoordinates = [85, 27]; // [longitude, latitude]


export default {
  name: 'LandCover',
  data() {
    return {
      map: null,
      formInline: {
        adminLevel: 0,
        adminLevelId: '',
        year: '2024',
        province: 0,
        district: 0,
        municipality: 0,
        radioNav: 'Admin',
        physioId: '',
        plottype: 'Distribution'
      },
      adminLevelVal: null,
      LCoptions: LCYear,
      provinceOption: ProvinceOption,
      districtOption: DistrictOption,
      municipalityOption: municipalityOption,
      adminLevelOption: AdministrativeLabelOption,
      plottypeOption: PlotType,
      adminLevelOptionList: [],
      physiographyOptionList: [],
      LCLayerList: [],
      LCImageSourceList: [],
      legendValues: LegendValues,
      colors: [
        {id: 1, label: "Water", color: "rgba(65, 155, 223, 1)", rgba: [65, 155, 223, 1]},
        {id: 2, label: "Trees", color: "rgba(57, 125, 73, 1)", rgba: [57, 125, 73, 1]},
        // {id: 4, label: "Flooded vegetation", color: "rgba(122, 135, 198, 1)", rgba: [122, 135, 198, 1]},
        {id: 5, label: "Crops", color: "rgba(228, 150, 53, 1)", rgba: [228, 150, 53, 1]},
        {id: 7, label: "Built Area", color: "rgba(196, 40, 27, 1)", rgba: [196, 40, 27, 1]},
        {id: 8, label: "Bare ground", color: "rgba(165, 155, 143, 1)", rgba: [165, 155, 143, 1]},
        {id: 9, label: "Snow/Ice", color: "rgba(168, 235, 255, 1)", rgba: [168, 235, 255, 1]},
        // {id: 10, label: "Clouds", color: "rgba(97, 97, 97, 1)", rgba: [97, 97, 97, 1]},
        {id: 11, label: "Rangeland", color: "rgba(227, 226, 195, 1)", rgba: [227, 226, 195, 1]}
      ],
      checkedValues: Array(9).fill(true), // Initialize an array with false values,
      highchartsObject: null,
      HCDataOneYear: null,
      HCDataTrend: null

    }
  },
  methods: {
    imagePostFunction,
    onSubmit: () => {
      console.log('submit!')
    },
    changeProvince(val) {
      let selObj = this.provinceOption.filter((a) => {
        return a.value == val
      })
      if (selObj.length) {
        this.updateExtent(selObj[0].extent)
      }
    },
    changeDistrict(val) {
      let selObj = this.districtOption.filter((a) => {
        return a.value == val
      })
      if (selObj.length) {
        this.updateExtent(selObj[0].extent)
      }
    },
    changeMunicipality(val) {
      let selObj = this.municipalityOption.filter((a) => {
        return a.value == val
      })
      if (selObj.length) {
        this.updateExtent(selObj[0].extent)
      }
    },
    updateExtent(extent) {
      this.map.getView().fit(extent, this.map.getViewport())
    },
    updateLayerCrop(coords, coodType) {

      let f = null;

      if (coodType == 'Polygon') {
        f = new Feature(new Polygon(coords));
      } else {
        f = new Feature(new MultiPolygon(coords));
      }
      var crop = new Crop({
        feature: f,
        wrapX: true,
        inner: false
      });

      this.LCLayerList.forEach((lyr) => {
        let InitialFilterList = lyr.getFilters();
        InitialFilterList.forEach((cropfil) => {
          lyr.removeFilter(cropfil);
        });
        lyr.addFilter(crop);
      });

    },
    changeYear(val) {

      this.changeAnalysisChange();

      let rasterLayer = this.LCLayerList.filter((a) => {
        let bolleana = a.getProperties().id == 'LandCover_' + val;
        if (bolleana) {
          a.setVisible(true)
        } else {
          a.setVisible(false)
        }
        return bolleana
      });

      if (rasterLayer.length) {

        console.log("inside");
      }
    },
    updateDefaultAminLevelSel() {
      setTimeout(() => {
        this.formInline.adminLevelId = this.adminLevelOptionList[0].value;
        this.updateExtent(this.adminLevelOptionList[0].extent);
        this.getLCAreaData();
      }, 0)
    },
    changeAdminLevel(val) {

      if (val == 0) {
        this.updateExtent(NepalExtent);
        this.getLCAreaData();
      } else if (val == 1) {
        this.adminLevelOptionList = ProvinceOption;
        this.updateDefaultAminLevelSel();
      } else if (val == 2) {
        this.adminLevelOptionList = DistrictOption;
        this.updateDefaultAminLevelSel();
      } else if (val == 3) {
        this.adminLevelOptionList = municipalityOption;
        this.updateDefaultAminLevelSel();
      }

    },
    changeDefaultAminLevelSel(val) {
      this.getLCAreaData();
      let selObj = this.adminLevelOptionList.filter((a) => {
        return a.value == val
      })
      if (selObj.length) {
        this.updateExtent(selObj[0].extent)
      }
    },
    PopulateLayerList() {
      for (let i of this.LCoptions) {
        let tileWMSSource_ = new ImageWMS({
          url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
          params: {'LAYERS': 'NepalLandCoverFinal' + i.value, 'TILED': true},
          serverType: 'geoserver',
          // Countries have transparency, so do not fade tiles:
          transition: 0,
          crossOrigin: 'Anonymous',
          imageLoadFunction: (image, src) => {
            this.imagePostFunction(image, src);
          },
        });

        this.LCImageSourceList.push(tileWMSSource_);


        const raster = new RasterSource({
          sources: [tileWMSSource_,],
          operation: function (pixels) {
            // this is for the first layer on sourves list
            const pixel = pixels[0];
            if (pixel[0] == 255 && pixel[1] == 255 && pixel[0] == 255) {
              pixel[0] = 0;
              pixel[1] = 0;
              pixel[2] = 0;
              pixel[3] = 0;
            }
            return pixel;
          },
          baseLayer: false,
        });

        let RasterLayer = new ImageLayer({
          displayInLayerSwitcher: false,
          id: 'LandCover_' + i.value,
          title: 'Landcover',
          baseLayer: false,
          source: raster,
          visible: this.formInline.year == i.value,
          opacity: 1
        });
        this.LCLayerList.push(RasterLayer);
        this.map.addLayer(RasterLayer);

        raster.on('beforeoperations', (event) => {

          event.data.LCCheckedValues = JSON.parse(JSON.stringify(this.checkedValues));
          event.data.colors = JSON.parse(JSON.stringify(this.colors));

        });

      }
    },
    handleLCCheckboxChange(index) {
      this.LCLayerList.forEach((val) => {
        let OperationFunction = function (pixels, data) {
          // this is for the first layer on sourves list
          const pixel = pixels[0];
          // remove white area in map
          if (pixel[0] == 255 && pixel[1] == 255 && pixel[2] == 255) {
            pixel[0] = 0;
            pixel[1] = 0;
            pixel[2] = 0;
            pixel[3] = 0;
          }

          data.colors.forEach((Colval, ind) => {
            if (!data.LCCheckedValues[ind]) {
              if (pixel[0] == Colval.rgba[0] && pixel[1] == Colval.rgba[1] && pixel[2] == Colval.rgba[2]) {
                pixel[0] = 0;
                pixel[1] = 0;
                pixel[2] = 0;
                pixel[3] = 0;
              }
            }
          })

          return pixel;
        }

        val.getSource().setOperation(OperationFunction);

      });
      if (this.formInline.plottype != 'DistributionPercentage') {
        const series = this.highchartsObject.series[index];
        if (this.checkedValues[index]) {
          series.show();
        } else {
          series.hide();
        }

      }

    },
    makeHCObject(catego, seriesData, title, ChartType) {
      return {
        chart: {
          // type: 'column',
          type: ChartType,
        },
        title: {
          text: title + ' of Different Land Cover Types by Area',
          // align: 'left'
        },
        subtitle: {
          text: '',
          align: 'left'
        },
        xAxis: {
          categories: catego,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Area in Hectare'
          }
        },
        tooltip: {
          valueSuffix: ' Ha'
        },
        credits: {
          enabled: false
        },
        plotOptions: {},
        series: seriesData
      }

    },
    makeHCObjectPie(seriesData, title) {
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: title + ' of Different Land Cover Types by Area',
          // align: 'left'
        },
        subtitle: {
          text: '',
          align: 'left'
        },
        tooltip: {
          valueSuffix: ' %'
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<span style="font-size: 1.2em"><b>{point.name}</b>' +
                  '</span><br>' +
                  '<span style="opacity: 0.6">{point.percentage:.1f} ' +
                  '%</span>',
              connectorColor: 'rgba(128,128,128,0.5)'
            }
          }
        },
        series: [
          {
            name: 'Percentage',
            colorByPoint: true,
            data: seriesData
          }],
        legend: {
          align: 'right',           // Align legend to the left
          verticalAlign: 'top',    // Place legend at the top vertically
          layout: 'vertical',      // Arrange legend items vertically
          x: 0,                    // Position from the left
          y: 0                    // Position from the top
        }
      }

    },
    // This is only for testing
    makeChartPlot() {
      this.highchartsObject = Highcharts.chart('chartArea', {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Distribution of Different Land Cover Types by Area',
          // align: 'left'
        },
        subtitle: {
          text: '',
          align: 'left'
        },
        xAxis: {
          categories: ['2017', '2018', '2019', '2020', '2021', '2022', '2023'],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Area in Hectare'
          }
        },
        tooltip: {
          valueSuffix: ' Ha'
        },
        credits: {
          enabled: false
        },
        plotOptions: {},
        series: [
          {
            name: 'Water',
            data: [387749, 280000, 129000, 64300, 54000, 34300],
            color: 'rgba(65, 155, 223, 1)'
          },
          {
            name: 'Trees',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(57, 125, 73, 1)'
          },
          {
            name: 'Flooded vegetation',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(122, 135, 198, 1)'
          },
          {
            name: 'Crops',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(228, 150, 53, 1)'
          },
          {
            name: 'Built Area',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(196, 40, 27, 1)'
          },
          {
            name: 'Bare ground',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(165, 155, 143, 1)'
          },
          {
            name: 'Snow/Ice',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(168, 235, 255, 1)'
          },
          {
            name: 'Clouds',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(97, 97, 97, 1)'
          },
          {
            name: 'Rangeland',
            data: [45321, 140000, 10000, 140500, 19500, 113500],
            color: 'rgba(227, 226, 195, 1)'
          }
        ]
      });
    },
    getLCAreaData() {

      this.changeDistributionTrend();

    },
    addRemoveFilter(geojson) {

      console.log(this.LCLayerList);

      console.log(this.LCLayerList.length);

      this.LCLayerList.forEach((lyr) => {
        var f = new Feature(new Polygon(geojson));
        var mask = new Mask({
          feature: f,
          wrapX: true,
          inner: false,
          fill: new Fill({color: [255, 255, 255, 0.8]})
        });
        console.log(mask);
        console.log(lyr);
        // lyr.addFilter(mask);
      });
      // osm.addFilter(mask);
    },
    populatePhysiographicArea() {
      const url = `${hosts}/v1/geo/physiographicOptionnepal/`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
          })
          .then(data => {

            this.physiographyOptionList = data.optionData;
            this.formInline.physioId = this.physiographyOptionList[0].value
          });

    },
    changeAnalysisChange(){
      if(this.formInline.radioNav=='Admin'){

        this.changeDistributionTrend();

      }else{

        this.changeDistributionTrendPhysio();

      }
    },
    changeDistributionTrend() {

      const payload = {
        adminLevel: this.formInline.adminLevel,
        selAdminID: this.formInline.adminLevelId,
        country: "Nepal",
        Year: parseInt(this.formInline.year)
      };

      // Trend
      if (this.formInline.plottype == 'Trend') {
        const url = `${hosts}/v1/geo/lctrendTrend/`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type)

              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });
              let HCObject = this.makeHCObject(data.cat, newSeriesDataList, "Trend", "spline")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson)

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });

      } else if (this.formInline.plottype == 'Distribution') {

        //Distribution
        const url = `${hosts}/v1/geo/lcstatrdas/`;
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateExtent(data.BBOXExtent);

              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type)

              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });


              let HCObject = this.makeHCObject(data.cat, newSeriesDataList, "Distribution", "column")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson);

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });

      } else {

        //Distribution
        const url = `${hosts}/v1/geo/lcstatrdas/`;
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateExtent(data.BBOXExtent);
              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type);

              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });


              let SumArea = 0
              newSeriesDataList.forEach((obj) => {
                SumArea = SumArea + obj.data[0];
              });

              newSeriesDataList.forEach((obj) => {
                let y = obj.data[0] * 100 / SumArea;
                y = Math.round(y * 100) / 100
                obj.y = y;
                delete obj['data'];
              });

              console.log(newSeriesDataList)


              let HCObject = this.makeHCObjectPie(newSeriesDataList, "Distribution")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson);

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });


      }
    },
    changeDistributionTrendPhysio() {

      const payload = {
        adminLevel: 10,
        selAdminID: this.formInline.physioId,
        country: "Nepal",
        Year: parseInt(this.formInline.year)
      };

      // Trend
      if (this.formInline.plottype == 'Trend') {
        const url = `${hosts}/v1/geo/lctrendTrendnepalphysio/`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateExtent(data.BBOXExtent);
              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type);
              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });
              let HCObject = this.makeHCObject(data.cat, newSeriesDataList, "Trend", "spline")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson)

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });

      } else if (this.formInline.plottype == 'Distribution') {

        //Distribution
        const url = `${hosts}/v1/geo/lcstatnepalphysio/`;
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateExtent(data.BBOXExtent);

              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type)

              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });


              let HCObject = this.makeHCObject(data.cat, newSeriesDataList, "Distribution", "column")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson);

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });

      } else {

        //Distribution
        const url = `${hosts}/v1/geo/lcstatnepalphysio/`;
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then(data => {
              this.updateExtent(data.BBOXExtent);
              this.updateLayerCrop(data.wkt.coordinates, data.wkt.type);

              let newSeriesDataList = data.seriesData.filter((obj) => {
                let retVal = null;
                if (obj.name == "Clouds") {
                  retVal = false;
                } else if (obj.name == "Flooded vegetation") {
                  retVal = false;
                } else {
                  retVal = true;
                }
                return retVal;
              });


              let SumArea = 0
              newSeriesDataList.forEach((obj) => {
                SumArea = SumArea + obj.data[0];
              });

              newSeriesDataList.forEach((obj) => {
                let y = obj.data[0] * 100 / SumArea;
                y = Math.round(y * 100) / 100
                obj.y = y;
                delete obj['data'];
              });

              console.log(newSeriesDataList)


              let HCObject = this.makeHCObjectPie(newSeriesDataList, "Distribution")
              this.HCDataOneYear = HCObject;
              this.highchartsObject = Highcharts.chart('chartArea', HCObject);

              // this.addRemoveFilter(data.geojson);

            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });


      }
    },
    adminPhysioChange() {
      if (this.formInline.radioNav == 'Admin') {
        this.changeDefaultAminLevelSel();
      } else {
        this.changeDistributionTrendPhysio();
      }

    }
  },
  mounted() {


    // Two base layers
    var satelliteLayer = new Geoportail({
      title: 'Satellite Imaginary',
      baseLayer: true,
      visible: false,
      layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
      opacity: 0.4
    })

    var osm = new TileLayer({
      opacity: 0.4,
      title: "OSM",
      baseLayer: true,
      source: new OSM(),
      visible: true
    });

    var openTopomap = new TileLayer({
      baseLayer: true,
      source: new XYZSource({
        url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
      }),
      title: "Open Topo Map",
      visible: false,
      opacity: 0.4,
    })


    // raster.set('threshold', 0.25);
    // console.log(this.legendValues)
    // var baseLayers = new Group({
    //   title: 'Base Layers',
    //   openInLayerSwitcher: true,
    //   layers: [
    //     new Geoportail({
    //       title: 'Satellite Imaginary',
    //       baseLayer: true,
    //       visible: false,
    //       layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
    //       opacity: 0.4
    //     }),
    //     new Geoportail({
    //       baseLayer: true,
    //       visible: false,
    //       layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
    //     }),
    //     new TileLayer({
    //       opacity: 0.4,
    //       title: "OSM",
    //       baseLayer: true,
    //       source: new OSM(),
    //       visible: true
    //     })
    //   ]
    // });

    // let adminBoundary = new ImageLayer({
    //   displayInLayerSwitcher: true,
    //   title: "Administrative Boundary",
    //   baseLayer: false,
    //   source: new ImageWMS({
    //     url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
    //     params: {
    //       'LAYERS': 'advise:np_country,advise:np_province,advise:np_district,advise:np_gapanapa',
    //       'TILED': true
    //     },
    //     serverType: 'geoserver',
    //     // Countries have transparency, so do not fade tiles:
    //     transition: 0,
    //     crossOrigin: 'anonymous',
    //   }),
    //   visible: true
    // })

    let GeoServerWMSURL = `${hosts}/v1/geo/lcproxy/geoserver/ows`
    let WMSURLWithRequestParameter = GeoServerWMSURL + encodeURIComponent('?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=')
    // let WMSURLWithRequestParameter = GeoServerWMSURL + `?service=WMS&version=1.3.0&request=GetLegendGraphic&format=${'image/png'}&width=20&height=20&layer=`

    // ?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=advise%3Anp_country
    // ?service=WMS&request=GetLegendGraphic&version=1.3.0&format=image%2Fpng&width=20&height=20&layer=advise%3Anp_country

    let CountryBoundary = new ImageLayer({
      displayInLayerSwitcher: false,
      title: "Country Boundary",
      id: 'NepalCountryBoundry',
      baseLayer: false,
      zIndex: 15,
      legendPath: WMSURLWithRequestParameter + encodeURIComponent('advise:np_country'),
      source: new ImageWMS({
        url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
        params: {
          'LAYERS': 'advise:np_country',
          'TILED': true
        },
        serverType: 'geoserver',
        // Countries have transparency, so do not fade tiles:
        transition: 0,
        crossOrigin: 'anonymous',
      }),
      visible: true
    });
    let ProvinceBoundary = new ImageLayer({
      displayInLayerSwitcher: false,
      title: "Province Boundary",
      id: 'NepalProvinceBoundry',
      baseLayer: false,
      zIndex: 14,
      legendPath: WMSURLWithRequestParameter + encodeURIComponent('advise:np_province'),
      source: new ImageWMS({
        url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
        params: {
          'LAYERS': 'advise:np_province',
          'TILED': true
        },
        serverType: 'geoserver',
        // Countries have transparency, so do not fade tiles:
        transition: 0,
        crossOrigin: 'anonymous',
      }),
      visible: true
    });
    let districtBoundary = new ImageLayer({

      displayInLayerSwitcher: false,
      title: "District Boundary",
      id: 'NepalDistrictBoundry',
      baseLayer: false,
      zIndex: 13,
      legendPath: WMSURLWithRequestParameter + encodeURIComponent('advise:np_district'),
      source: new ImageWMS({
        url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
        params: {
          'LAYERS': 'advise:np_district',
          'TILED': true
        },
        serverType: 'geoserver',
        // Countries have transparency, so do not fade tiles:
        transition: 0,
        crossOrigin: 'anonymous',
      }),
      visible: true
    });
    let municipalityBoundary = new ImageLayer({
      displayInLayerSwitcher: false,
      title: "Municipality Boundary",
      id: 'NepalMunicipalityBoundry',
      baseLayer: false,
      zIndex: 12,
      legendPath: WMSURLWithRequestParameter + encodeURIComponent('advise:np_gapanapa'),
      source: new ImageWMS({
        url: `${hosts}/v1/geo/lcproxy/geoserver/advise/wms`,
        params: {
          'LAYERS': 'advise:np_gapanapa',
          'TILED': true
        },
        serverType: 'geoserver',
        // Countries have transparency, so do not fade tiles:
        transition: 0,
        crossOrigin: 'anonymous',
      }),
      visible: true
    });

    console.log(CountryBoundary);
    console.log(ProvinceBoundary);
    console.log(districtBoundary);
    console.log(municipalityBoundary);


    const layers = [satelliteLayer, osm, openTopomap];
    this.map = new Map({
      layers: layers,
      target: 'map',
      view: new View({
        center: fromLonLat(centerCoordinates),
        zoom: 8,
      }),
    });
    this.updateExtent(NepalExtent);

    // var ctrl = new LayerSwitcher({
    //   // collapsed: false,
    //   // mouseover: true
    // });

    var ctrl = new LayerSwitcherImage({collapsed: false});
    ctrl.isOpen(true)

    // Add a new Layerswitcher to the map
    this.map.addControl(ctrl);


    this.map.addLayer(CountryBoundary);
    let l1 = new OLPlusLayerSwitcher(".layerCollection", CountryBoundary, false);
    l1.setVisibleDivBind(true);

    this.map.addLayer(ProvinceBoundary);
    let l2 = new OLPlusLayerSwitcher(".layerCollection", ProvinceBoundary, false);
    l2.setVisible(false);

    this.map.addLayer(districtBoundary);
    let l3 = new OLPlusLayerSwitcher(".layerCollection", districtBoundary, false);
    l3.setVisible(false);

    this.map.addLayer(municipalityBoundary);
    let l4 = new OLPlusLayerSwitcher(".layerCollection", municipalityBoundary, false);
    l4.setVisible(false);


    // let newControl = new Control({element: document.getElementById("expandCustomControl")})
    // this.map.addControl(newControl)
    let newLegendControl = new Control({element: document.getElementById("LegendId")})
    this.map.addControl(newLegendControl)
    this.PopulateLayerList();

    this.getLCAreaData();

    // this.makeChartPlot();

    this.populatePhysiographicArea();
  }
}
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #78988d;
}

.div1 {
  /*background-color: lightblue;*/
  height: calc(55% - 15px);
  width: calc(100% - 20px);
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
}

.div2 {
  /*background-color: lightcoral;*/
  height: calc(45% - 15px);
  width: calc(100% - 20px);
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-left: 10px;

}

.full-height {
  height: 100%;
}

.full-width {
  width: 100%;
}

div#expandCustomControl {
  /*background-color: #ffffff;*/
  /*padding-top: 20px;*/
  /*position: absolute;*/
  /*left: 0px;*/
  padding: 10px 0px 10px 10px;
}


.legendSection .ledsp {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 1px solid #333;
  position: absolute;
  top: 7.5px;
}

#LegendId {
  position: absolute;
  left: 5px;
  bottom: 5px;
  background-color: white;
  border: 1px #cccccc solid;
  padding-bottom: 10px;
}

.allLC {
  display: flex;
  padding-left: 10px;
  flex-direction: column;
}


/*.ol-zoom {*/
/*  top: 5.5em;*/
/*}*/

#map {
  background-color: white;
}


.checkboxTs {
  position: relative;
}

.inputcheck {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 99;
  display: inline;
}

.tilteLegend {
  padding: 8px 0px;
}

span.el-switch__label span {
  font-weight: bold;

}

.overlayCustom {
  height: calc(100% - 20px);
  width: calc(100% - 10px);
}

.demo-form-inline-div {
  background: white;
  height: 100%;
  width: 100%;
}

/*.demo-form-inline {*/
/*  background: white;*/
/*}*/

div#chartArea {
  background-color: white;
}

.pannelTitle {
  background-color: #0b6623;
  color: white;
  font-weight: bold;
  padding: 10px;
}

.divSide1 {
  height: calc(50% - 38px); /* 100% of the viewport height minus 50 pixels */
}

.divSide2 {
  height: calc(30% - 38px); /* 100% of the viewport height minus 50 pixels */
}

.divSide3 {
  height: calc(20% - 48px); /* 100% of the viewport height minus 50 pixels */
}

.allLC .el-checkbox {
  margin-bottom: -10px
}

.vertical-radio-group {
  display: flex;
  flex-direction: column;
}

.demo-form-inline {
  padding: 10px;
}

.el-form-item__label {
  font-weight: bold;
}


.formcss {
  width: calc(100% - 20px);
}

.infoabout {
  padding: 5px;
  text-align: justify;

}

.infoabout h3 {
  margin: 0px;
}

.el-radio-button.is-active .el-radio-button__original-radio:not(:disabled)+.el-radio-button__inner {
    background-color: #0b6623;
}
</style>


